module.exports = __webpack_public_path__ + "img/abo9.529f1f54.jpg";